import React from 'react';

// Gothic Arch Divider
export const GothicArch = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 200 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 30 L85 30 Q100 5 100 0 Q100 5 115 30 L200 30" stroke="currentColor" strokeWidth="0.5" opacity="0.2" fill="none"/>
  </svg>
);

// Monastery Seal/Crest
export const MonasterySeal = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="19" stroke="currentColor" strokeWidth="0.5" opacity="0.3"/>
    <circle cx="20" cy="20" r="15" stroke="currentColor" strokeWidth="0.5" opacity="0.2"/>
    <path d="M15 20 Q20 15 25 20 Q20 25 15 20" fill="currentColor" opacity="0.15"/>
    <path d="M20 12 L20 28 M12 20 L28 20" stroke="currentColor" strokeWidth="0.5" opacity="0.25"/>
  </svg>
);

// Ornamental Bracket (for section labels)
export const OrnamentalBracket = ({ className = "", side = "left" }) => (
  <svg className={className} viewBox="0 0 20 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    {side === 'left' ? (
      <path d="M15 0 Q5 0 5 20 Q5 40 15 40" stroke="currentColor" strokeWidth="0.5" opacity="0.2" fill="none"/>
    ) : (
      <path d="M5 0 Q15 0 15 20 Q15 40 5 40" stroke="currentColor" strokeWidth="0.5" opacity="0.2" fill="none"/>
    )}
  </svg>
);

// Decorative Line Break
export const DecorativeLine = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 100 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 5 L30 5 M35 5 L40 5 Q45 5 45 7 Q45 5 50 5 Q55 5 55 7 Q55 5 60 5 L65 5 M70 5 L100 5" stroke="currentColor" strokeWidth="0.5" opacity="0.15"/>
  </svg>
);

// Small Monastery Mark (between words)
export const MonasteryMark = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="1.5" fill="currentColor" opacity="0.3"/>
    <circle cx="10" cy="10" r="3" stroke="currentColor" strokeWidth="0.3" opacity="0.15"/>
  </svg>
);

// Detailed Monastery Vector Illustration
export const MonasteryIllustration = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 400 500" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Bell Tower */}
    <rect x="170" y="50" width="60" height="150" stroke="currentColor" strokeWidth="0.5" opacity="0.15" />
    <path d="M165 50 L205 30 L245 50" stroke="currentColor" strokeWidth="0.5" opacity="0.15" />
    <circle cx="200" cy="120" r="8" stroke="currentColor" strokeWidth="0.5" opacity="0.12" />
    
    {/* Main Monastery Building */}
    <rect x="80" y="200" width="240" height="200" stroke="currentColor" strokeWidth="0.5" opacity="0.15" />
    
    {/* Gothic Arched Entrance */}
    <path d="M150 400 L150 320 Q150 280 200 280 Q250 280 250 320 L250 400" stroke="currentColor" strokeWidth="0.5" opacity="0.15" fill="none"/>
    
    {/* Gothic Windows - Left */}
    <path d="M100 250 L100 220 Q100 210 110 210 Q120 210 120 220 L120 250" stroke="currentColor" strokeWidth="0.4" opacity="0.12" fill="none"/>
    <path d="M130 250 L130 220 Q130 210 140 210 Q150 210 150 220 L150 250" stroke="currentColor" strokeWidth="0.4" opacity="0.12" fill="none"/>
    
    {/* Gothic Windows - Right */}
    <path d="M250 250 L250 220 Q250 210 260 210 Q270 210 270 220 L270 250" stroke="currentColor" strokeWidth="0.4" opacity="0.12" fill="none"/>
    <path d="M280 250 L280 220 Q280 210 290 210 Q300 210 300 220 L300 250" stroke="currentColor" strokeWidth="0.4" opacity="0.12" fill="none"/>
    
    {/* Roof Line */}
    <path d="M60 200 L200 160 L340 200" stroke="currentColor" strokeWidth="0.5" opacity="0.15" />
    
    {/* Cross on Tower */}
    <path d="M200 30 L200 50 M192 38 L208 38" stroke="currentColor" strokeWidth="0.5" opacity="0.15" />
    
    {/* Foundation Details */}
    <path d="M80 400 L320 400" stroke="currentColor" strokeWidth="0.8" opacity="0.12" />
    
    {/* Decorative Rose Window */}
    <circle cx="200" cy="240" r="15" stroke="currentColor" strokeWidth="0.4" opacity="0.1" />
    <path d="M200 225 L200 255 M185 240 L215 240" stroke="currentColor" strokeWidth="0.3" opacity="0.08" />
    
    {/* Side Chapels */}
    <rect x="50" y="300" width="30" height="100" stroke="currentColor" strokeWidth="0.4" opacity="0.1" />
    <path d="M50 300 L65 285 L80 300" stroke="currentColor" strokeWidth="0.4" opacity="0.1" />
    
    <rect x="320" y="300" width="30" height="100" stroke="currentColor" strokeWidth="0.4" opacity="0.1" />
    <path d="M320 300 L335 285 L350 300" stroke="currentColor" strokeWidth="0.4" opacity="0.1" />
    
    {/* Buttresses */}
    <path d="M80 250 L70 250 L70 400" stroke="currentColor" strokeWidth="0.3" opacity="0.08" />
    <path d="M320 250 L330 250 L330 400" stroke="currentColor" strokeWidth="0.3" opacity="0.08" />
  </svg>
);

// Simplified Monastery Silhouette (for subtle backgrounds)
export const MonasterySilhouette = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 300 400" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="130" y="40" width="40" height="100" stroke="currentColor" strokeWidth="0.4" opacity="0.08" />
    <path d="M125 40 L150 25 L175 40" stroke="currentColor" strokeWidth="0.4" opacity="0.08" />
    <rect x="60" y="140" width="180" height="160" stroke="currentColor" strokeWidth="0.4" opacity="0.08" />
    <path d="M120 300 L120 220 Q120 190 150 190 Q180 190 180 220 L180 300" stroke="currentColor" strokeWidth="0.4" opacity="0.08" fill="none"/>
    <path d="M40 140 L150 100 L260 140" stroke="currentColor" strokeWidth="0.4" opacity="0.08" />
    <path d="M150 20 L150 35 M145 27 L155 27" stroke="currentColor" strokeWidth="0.4" opacity="0.08" />
  </svg>
);